const FontFamilyList = [
    {name: 'Georgia, serif', nickname: 'Georgia'},
    {name: '"Times New Roman", Times, serif', nickname: 'Times New Roman'},
    {name: '"Palatino Linotype", "Book Antiqua", Palatino, serif', nickname: 'Palatino'},
    {name: 'Arial, Helvetica, sans-serif', nickname: 'Arial'},
    {name: '"Arial Black", Gadget, sans-serif', nickname: 'Arial Black'},
    {name: '"Comic Sans MS", cursive, sans-serif', nickname: 'Comic Sans'},
    {name: 'Impact, Charcoal, sans-serif', nickname: 'Impact'},
    {name: '"Lucida Sans Unicode", "Lucida Grande", sans-serif', nickname: 'Lucida'},
    {name: 'Tahoma, Geneva, sans-serif', nickname: 'Tahoma'},
    {name: '"Trebuchet MS", Helvetica, sans-serif', nickname: 'Trebuchet'},
    {name: 'Verdana, Geneva, sans-serif', nickname: 'Verdana'},
    {name: '"Courier New", Courier, monospace', nickname: 'Courier New'},
    {name: '"Lucida Console", Monaco, monospace', nickname: 'Lucida Console'},
    {name: 'cursive', nickname: 'cursive'},
    {name: 'fantasy', nickname: 'fantasy'},
]

const FontFamilyDefault = 'Georgia, serif'

export {
    FontFamilyList,
    FontFamilyDefault,
}